import {
  BibliographyTagRegisterData,
  BibliographyTagRegisterDataToJSON
} from '@/api/models'
import { SystemCode } from '@/api'

export interface BibliographyContentCreateRequest {
  searchType: SystemCode
  bibliographyRealId?: number
  serial?: number
  details: BibliographyTagRegisterData[]
}

export function BibliographyContentCreateRequestToJSON(
  value: BibliographyContentCreateRequest
): any {
  return {
    search_type: value.searchType.code,
    bibliography_real_id: value.bibliographyRealId ?? undefined,
    serial: value.serial ?? undefined,
    details: value.details.map(BibliographyTagRegisterDataToJSON)
  }
}
